import React, { useEffect, useState } from "react";
import { Button, Spinner } from "@material-tailwind/react";

import { BsPrinterFill } from "react-icons/bs";
import { getAllProductsCategoriesApi } from "api/filtersData";
import { getAllDepotsApi } from "api/depot";
import { productEssayInvetaireListApi as productInvetaireListApi } from "api/productsEssay";
import { pdfInvetaireGeneratorEssayApi as pdfInvetaireGeneratorApi } from "api/pdf";

function ProductInventaire({ closePopup }) {
  const [productsCategories, setProductsCategories] = useState([])
  const [listOfDepots, setListOfDepots] = useState([])
  const [listOfProducts, setListOfProducts] = useState([])

  const [inputFilterValue, setInputFilterValue] = useState({
    Categorie: "",
    Depot: "",
    Product: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const formatLotQuantity = (value) => {
    const parsedValue = parseFloat(value);
    if (isNaN(parsedValue)) return "-";
    return parsedValue.toFixed(2);
  };

  useEffect(() => {
    getInitialFilterData()
  }, [])

  useEffect(() => {
    getInitialData(inputFilterValue)
  }, [])

  const getInitialFilterData = async () => {
    try {
      const productsCategories = await getAllProductsCategoriesApi("")
      const depots = await getAllDepotsApi()

      setProductsCategories(productsCategories)
      setListOfDepots(depots)
    }
    catch (err) {
      console.log(err)
    }
  }

  const getInitialData = async (inputFilterValue) => {
    try {
      setIsLoading(true)
      const listOfProducts = await productInvetaireListApi(inputFilterValue)
      setListOfProducts(listOfProducts)
    }
    catch (err) {
      console.log(err)
    }
    finally {
      setIsLoading(false)
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target;
    setInputFilterValue({ ...inputFilterValue, [name]: value });

    if(name == "Categorie")
      inputFilterValue.Categorie = value
    if(name == "Depot")
      inputFilterValue.Depot = value
    if(name == "Product")
      inputFilterValue.Product = value

    getInitialData(inputFilterValue)
  }

  const handleCloseReleveOp = () => {
    try {
      closePopup("Close");
    } catch (err) {}
  };

  const handlePrintClientList = async () => {
    try {
      const response = await pdfInvetaireGeneratorApi(inputFilterValue)
      window.open(response, "_blank");
    }
    catch(err) {

    }
  }

  return (
    <div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-4">
        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par categorie :
          </small>
          <select
              label="select Version"
              className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}

              name="Categorie"
              value={inputFilterValue.Categorie}
              onChange={handleInputChange}
            >
              <option value="">Tout</option>

              {
                productsCategories.map(el => (
                  <option>{el.Name}</option>
                ))
              }
            </select>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par dépôt :
          </small>
          <select
              label="select Version"
              className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}

              name="Depot"
              value={inputFilterValue.Depot}
              onChange={handleInputChange}
            >
              <option value="">Tout</option>
              {
                listOfDepots.map(el => (
                  <option>{el.Name}</option>
                ))
              }
          </select>
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Filtrer par produit :
          </small>
          <input
            type="text"
            id=""
            placeholder="Tout"
            className={`mt-2 flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}

            name="Product"
            value={inputFilterValue.Product}
            onChange={handleInputChange}
          />
        </div>

        <div>
          <small className="text-sm font-medium text-gray-600 dark:text-white">
            Imprimer
          </small>
          <BsPrinterFill size={50} className="cursor-pointer" onClick={handlePrintClientList}  />
        </div>
      </div>

      {
        isLoading ?
        <div className="flex w-full items-center justify-center">
        <Spinner className="h-12 w-12" />
        </div> :
        <table className="w-full">
        <thead>
          <tr>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Code produit</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Produit</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Numéro de lot</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Qté dispo par lot</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Unité</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Dépôt</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Numéro de lot (Dépôt)</p>
            </th>
            <th className="border-b border-gray-200 pr-28 pb-[10px] text-start dark:!border-navy-700 pt-3 pb-3">
              <p className="text-sm tracking-wide text-gray-600">Disponible</p>
            </th>
          </tr>
        </thead>
        {
          inputFilterValue.Depot == "" ?
          <tbody>
          {
            listOfProducts.map(el => {
              if (el.IsEnabled === false) return null;
              const totalDispo = Array.isArray(el.Dispo)
                ? el.Dispo.reduce(
                    (previousValue, currentValue) =>
                      previousValue + Number(currentValue),
                    0
                  )
                : Number(el.Dispo || 0);

              if (totalDispo <= 0) return null;

              // flatten every depot's lots into one list, then sort by lot number so that
              // duplicate lot numbers (same lot split across depots) render on adjacent lines
              const depotLotRows = [];
              (el.Depot || []).forEach((depotName, depotIndex) => {
                const lots = (el.DepotLots && el.DepotLots[depotIndex]) || [];
                if (lots.length > 0) {
                  lots.forEach((lot) => {
                    depotLotRows.push({
                      depotName,
                      lotNumber: lot.lotNumber,
                      available: lot.available,
                    });
                  });
                } else {
                  depotLotRows.push({
                    depotName,
                    lotNumber: null,
                    available: el.Dispo[depotIndex],
                  });
                }
              });
              const sortedDepotLotRows = [...depotLotRows].sort((a, b) => {
                if (a.lotNumber === null && b.lotNumber === null) return 0;
                if (a.lotNumber === null) return 1;
                if (b.lotNumber === null) return -1;
                return String(a.lotNumber).localeCompare(String(b.lotNumber), undefined, { numeric: true });
              });

              // sum of Disponible across every depot sharing the same lot number
              const lotAvailableSumByLotNumber = new Map();
              sortedDepotLotRows.forEach((row) => {
                if (row.lotNumber === null) return;
                const previousSum = lotAvailableSumByLotNumber.get(row.lotNumber) || 0;
                lotAvailableSumByLotNumber.set(row.lotNumber, previousSum + Number(row.available));
              });

              return (
              <tr>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700">
                    {el.CodeProduct}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700">
                    {el.Product}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.Depot.map((depotName, depotIndex) => {
                    const lots = (el.DepotLots && el.DepotLots[depotIndex]) || [];
                    if (lots.length > 0) {
                      return lots.map((lot, lotIndex) => (
                        <p
                          key={`${el.CodeProduct}-lotnum-${depotIndex}-${lotIndex}`}
                          className="text-sm font-bold text-navy-700"
                        >
                          {lot.lotNumber}
                        </p>
                      ));
                    }
                    return (
                      <p
                        key={`${el.CodeProduct}-lotnum-${depotIndex}`}
                        className="text-sm font-bold text-navy-700"
                      >
                        -
                      </p>
                    );
                  })}
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.LotNumbers && el.LotNumbers.length > 0 ? (() => {
                    const rows = el.LotNumbers
                      .map((_, lotIndex) => {
                        const qty =
                          el.LotNumbersAvailable && el.LotNumbersAvailable[lotIndex] !== undefined
                            ? parseFloat(el.LotNumbersAvailable[lotIndex])
                            : 0;
                        if (qty <= 0) return null;
                        return (
                          <p
                            key={`${el.CodeProduct}-lotQty-${lotIndex}`}
                            className="text-sm font-bold text-navy-700"
                          >
                            {formatLotQuantity(qty)}
                          </p>
                        );
                      })
                      .filter(Boolean);
                    return rows.length ? rows : <p className="text-sm font-bold text-navy-700">-</p>;
                  })() : (
                    <p className="text-sm font-bold text-navy-700">-</p>
                  )}
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700">
                    {el.Unite}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {sortedDepotLotRows.map((row, rowIndex) => (
                    <React.Fragment key={`${el.CodeProduct}-depot-${rowIndex}`}>
                      <p className="text-sm font-bold text-navy-700">
                        {row.depotName}
                      </p>
                      {rowIndex < sortedDepotLotRows.length - 1 &&
                        sortedDepotLotRows[rowIndex + 1].lotNumber !== row.lotNumber && (
                        <hr className="my-1 border-gray-300 dark:border-gray-600" />
                      )}
                    </React.Fragment>
                  ))}
                  <p className="text-lg font-bold">-</p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {sortedDepotLotRows.map((row, rowIndex) => (
                    <React.Fragment key={`${el.CodeProduct}-depotlot-${rowIndex}`}>
                      <p className="text-sm font-bold text-navy-700">
                        {row.lotNumber ? `${row.lotNumber} : ${Number(row.available).toFixed(2)}` : "-"}
                      </p>
                      {rowIndex < sortedDepotLotRows.length - 1 &&
                        sortedDepotLotRows[rowIndex + 1].lotNumber !== row.lotNumber && (
                        <hr className="my-1 border-gray-300 dark:border-gray-600" />
                      )}
                    </React.Fragment>
                  ))}
                  <p className="text-lg font-bold">-</p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {sortedDepotLotRows.map((row, rowIndex) => {
                    const displayValue =
                      row.lotNumber !== null
                        ? lotAvailableSumByLotNumber.get(row.lotNumber)
                        : Number(row.available);
                    return (
                      <React.Fragment key={`${el.CodeProduct}-dispo-${rowIndex}`}>
                        <p className="text-sm font-bold text-navy-700">
                          {Number(displayValue).toFixed(2)}
                        </p>
                        {rowIndex < sortedDepotLotRows.length - 1 &&
                          sortedDepotLotRows[rowIndex + 1].lotNumber !== row.lotNumber && (
                          <hr className="my-1 border-gray-300 dark:border-gray-600" />
                        )}
                      </React.Fragment>
                    );
                  })}
                  <p className="text-lg font-bold">
                    {el.Dispo.reduce(
                      (previousValue, currentValue) =>
                        previousValue + Number(currentValue),
                      0
                    ).toFixed(2)}
                  </p>
                </td>
              </tr>
            )})
          }
          </tbody>
          :
          <tbody>
          {
            listOfProducts.map(el => {
              if (el.IsEnabled === false) return null;
              const totalDispo = Array.isArray(el.Dispo)
                ? el.Dispo.reduce(
                    (previousValue, currentValue) =>
                      previousValue + Number(currentValue),
                    0
                  )
                : Number(el.Dispo || 0);

              if (totalDispo <= 0) return null;

              return (
              <tr>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700">
                    {el.CodeProduct}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700">
                    {el.Product}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.DepotLots && el.DepotLots.length > 0 ? (
                    el.DepotLots.map((lot, lotIndex) => (
                      <p
                        key={`${el.CodeProduct}-${el.Depot}-lotnum-${lotIndex}`}
                        className="text-sm font-bold text-navy-700"
                      >
                        {lot.lotNumber}
                      </p>
                    ))
                  ) : (
                    <p className="text-sm font-bold text-navy-700">-</p>
                  )}
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.LotNumbers && el.LotNumbers.length > 0 ? (() => {
                    const rows = el.LotNumbers
                      .map((_, lotIndex) => {
                        const qty =
                          el.LotNumbersAvailable && el.LotNumbersAvailable[lotIndex] !== undefined
                            ? parseFloat(el.LotNumbersAvailable[lotIndex])
                            : 0;
                        if (qty <= 0) return null;
                        return (
                          <p
                            key={`${el.CodeProduct}-lotQty-${lotIndex}`}
                            className="text-sm font-bold text-navy-700"
                          >
                            {formatLotQuantity(qty)}
                          </p>
                        );
                      })
                      .filter(Boolean);
                    return rows.length ? rows : <p className="text-sm font-bold text-navy-700">-</p>;
                  })() : (
                    <p className="text-sm font-bold text-navy-700">-</p>
                  )}
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  <p className="text-sm font-bold text-navy-700">
                    {el.Unite}
                  </p>
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.DepotLots && el.DepotLots.length > 0 ? (
                    el.DepotLots.map((lot, lotIndex) => (
                      <p
                        key={`${el.CodeProduct}-${el.Depot}-depot-${lotIndex}`}
                        className="text-sm font-bold text-navy-700"
                      >
                        {el.Depot}
                      </p>
                    ))
                  ) : (
                    <p className="text-sm font-bold text-navy-700">
                      {el.Depot}
                    </p>
                  )}
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.DepotLots && el.DepotLots.length > 0 ? (
                    el.DepotLots.map((lot, lotIndex) => (
                      <p
                        key={`${el.CodeProduct}-${el.Depot}-depotlot-${lotIndex}`}
                        className="text-sm font-bold text-navy-700"
                      >
                        {lot.lotNumber} : {Number(lot.available).toFixed(2)}
                      </p>
                    ))
                  ) : (
                    <p className="text-sm font-bold text-navy-700">-</p>
                  )}
                </td>
                <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                  {el.DepotLots && el.DepotLots.length > 0 ? (
                    el.DepotLots.map((lot, lotIndex) => (
                      <p
                        key={`${el.CodeProduct}-${el.Depot}-dispo-${lotIndex}`}
                        className="text-sm font-bold text-navy-700"
                      >
                        {Number(lot.available).toFixed(2)}
                      </p>
                    ))
                  ) : (
                    <p className="text-sm font-bold text-navy-700">
                      {Number(el.Dispo).toFixed(2)}
                    </p>
                  )}
                </td>
              </tr>
            )})
          }
          </tbody>
        }
        </table>
      }

      <div className="mt-5">
        <Button
          onClick={() => handleCloseReleveOp()}
          className="linear rounded-[10px] bg-gray-500 font-bold text-white transition duration-200 hover:bg-gray-400 active:bg-gray-900 dark:bg-gray-400 dark:hover:bg-gray-300 dark:active:opacity-90"
        >
          Fermer
        </Button>
      </div>
    </div>
  );
}

export default ProductInventaire;
